import React, { useEffect, useState } from 'react';

import { Button, Image } from 'react-bootstrap';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';

import iconStatusOnline from '../../assets/icon/statusOnline.svg';
import iconStatusAusente from '../../assets/icon/statusAusente.svg';
import iconStatusOcupado from '../../assets/icon/statusOcupado.svg';

import { userStatus } from '../../enums/userStatus';
import { useAuth } from '../../hooks/auth';
import { getStatusIcon } from '../../services/function';

type PropsUserPerfil = {
  setShowUserPerfil: React.Dispatch<React.SetStateAction<boolean>>;
  showUserPerfil: boolean;
  status: number;
  nameInitials: string;
};

//
const StatusUserHeader: React.FC<any> = ({
  setShowUserPerfil,
  showUserPerfil,
  status,
  nameInitials,
}: PropsUserPerfil) => {
  const { corUser } = useAuth();
  const [statusIcon, setStatusIcon] = useState(iconStatusOnline);

  const showChevron = (show: boolean): JSX.Element => {
    if (show) return <FaChevronUp className="ms-2" size={12} />;

    return <FaChevronDown className="ms-2" size={12} />;
  };

  useEffect(() => {
    setStatusIcon(getStatusIcon(status));
  }, [status]);

  return (
    <div>
      <div
        className="d-flex align-items-end position-relative"
        style={{ color: '#fff', height: '3rem' }}
      >
        <Button
          className=" d-flex align-items-center bg-transparent border-0 shadow-none p-0 m-0"
          onClick={() => setShowUserPerfil(!showUserPerfil)}
        >
          <span
            className="p-1"
            style={{
              background: corUser, // 'linear-gradient(135deg, #0094FF 0%, #006DBC 100%) ',
              fontSize: '1.8rem',
              borderRadius: '0.8rem',
            }}
          >
            {nameInitials}
          </span>
          {showChevron(showUserPerfil)}
        </Button>
      </div>
      <Image
        className="position-absolute"
        style={{
          top: '2.1rem',
          right: '0.8rem',
          height: '1.2rem',
          width: '1.2rem',
        }}
        src={statusIcon}
        alt="Online"
      />
    </div>
  );
};

export default StatusUserHeader;
